import React, { useState, useEffect } from 'react';

export const fuelIqScreens = [
  '/images/fueliq/screen-1.webp',
  '/images/fueliq/screen-2.webp',
  '/images/fueliq/screen-3.webp',
  '/images/fueliq/screen-4.webp',
  '/images/fueliq/screen-5.webp',
  '/images/fueliq/screen-6.webp',
  '/images/fueliq/screen-7.webp',
  '/images/fueliq/screen-8.webp',
];

// Auto-playing "video" of the app screens inside a phone frame (seamless crossfade loop)
export const PhoneSlideshow = ({
  interval = 1800,
  widthClass = 'w-[260px] sm:w-[280px]',
  showDots = true,
  testid = 'fueliq-slideshow',
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const id = setInterval(
      () => setIndex((i) => (i + 1) % fuelIqScreens.length),
      interval
    );
    return () => clearInterval(id);
  }, [interval]);

  return (
    <div className="flex flex-col items-center gap-4" data-testid={testid}>
      <div
        className={`relative ${widthClass} rounded-[2.75rem] border-[12px] border-[#0a1f33] bg-[#0a1f33] shadow-2xl`}
      >
        <div className="relative w-full aspect-[250/510] overflow-hidden rounded-[1.9rem] bg-[#0a1f33]">
          {fuelIqScreens.map((src, i) => (
            <img
              key={src}
              src={src}
              alt={`FuelIQ app screen ${i + 1}`}
              loading="eager"
              className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ease-in-out ${
                i === index ? 'opacity-100' : 'opacity-0'
              }`}
            />
          ))}
        </div>
      </div>
      {showDots && (
        <div className="flex gap-1.5">
          {fuelIqScreens.map((_, i) => (
            <span
              key={i}
              className={`h-1.5 rounded-full transition-all duration-500 ${
                i === index ? 'w-5 bg-[#3BA6E0]' : 'w-1.5 bg-slate-300'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

// Single static app screen inside a phone frame
export const PhoneStill = ({ src, alt, widthClass = 'w-[200px]' }) => (
  <div
    className={`relative ${widthClass} mx-auto rounded-[2rem] border-[9px] border-[#0a1f33] bg-[#0a1f33] shadow-xl`}
  >
    <div className="relative w-full aspect-[250/510] overflow-hidden rounded-[1.4rem] bg-[#0a1f33]">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="absolute inset-0 h-full w-full object-cover"
      />
    </div>
  </div>
);
